import { PageType } from '../../common/page-types'
import { AdURI, AdURIFormatter } from './uri'

/**
 * This forms the equivalent of a page identifier for requests to an ad service.
 *
 * @param account
 * @param site
 * @param categories
 */
export const defaultAdURIFormatter: AdURIFormatter = (
    account: string,
    site: string,
    ancestry?: string[],
    type?: PageType): string => {

    return new AdURI(account)
        .add(site)

        // author type just uses string 'author'
        .addIf(type === PageType.AUTHOR, 'author')

        // category, page and story types use hierarchical slugs
        .addIf([PageType.CATEGORY, PageType.INDEX, PageType.PAGE, PageType.STORY].indexOf(type) >= 0,
            [...ancestry || []])

        // search type TODO
        .addIf(type === PageType.SEARCH, [])

        // tag type uses current slug
        .addIf(type === PageType.TAG, [...ancestry || []].shift())

        // suffix
        .add(type === PageType.STORY ? 'story' : 'index')

        .toString()
    }
